/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Preview_HintInputs */

const en_profile_preview_hint = /** @type {(inputs: Profile_Preview_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shown in the sidebar after you save.`)
};

const pt_br2_profile_preview_hint = /** @type {(inputs: Profile_Preview_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exibido na barra lateral após salvar.`)
};

/**
* | output |
* | --- |
* | "Shown in the sidebar after you save." |
*
* @param {Profile_Preview_HintInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_preview_hint = /** @type {((inputs?: Profile_Preview_HintInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Preview_HintInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_preview_hint(inputs)
	return pt_br2_profile_preview_hint(inputs)
});